import React, { useContext, useMemo } from 'react';

import ShopifyBurstContextProvider from 'lane-shared/hooks/integrations/shopify/ShopifyBurstContextProvider';
import { IntegrationProviderEnum } from 'constants-integrations';
import { UserDataContext } from 'lane-shared/contexts';
import { BEPrismTokenProvider } from 'lane-shared/contexts/BuildingEnginesPrism/useBEPrismTokenContext';
import { BEPrismBuildingsContextProvider as _BEPrismBuildingsContextProvider } from 'lane-shared/contexts/BuildingEnginesPrism/useBEPrismBuildingsContext';
import { convertToUUID } from 'uuid-encoding';

import RequestForm from 'components/integrations/AngusServiceRequests/RequestForm';
import BuildingEnginesClassicRequestForm from 'components/integrations/BuildingEnginesClassic/RequestForm';
import VisitForm from 'components/integrations/BuildingEnginesPrismVisitors/components/VisitForm';
import MeetingForm from 'components/integrations/ProxyClick/components/MeetingForm';
import BurstCreateFlow from 'components/integrations/ShopifyBurst/components/BurstCreateFlow';
import { useFlag } from 'lane-shared/hooks';
import { FeatureFlag } from 'constants-flags';

export default function ContentNewInteraction({ content, buildingId: selectedBuildingId, buildings }: any) {
  const integrationProvider = content?.integration?.integration?.name;
  const { user } = useContext(UserDataContext);
  const isBEFFEnabled = useFlag(
    FeatureFlag.EnableSSOAndMultiBuildingForBE,
    false
  );
  const buildingId = isBEFFEnabled 
    ? selectedBuildingId 
    : content?.integration?.settings?.buildingId;

  const tokenRequest = useMemo(() => {
    return {
      channelIntegrationId: content?.integration?._id
        ? convertToUUID(content?.integration?._id)
        : '',
      tenantData: {
        tenant_email: user?.profile?.email || '',
        tenant_account_id:
          content?.integration?.settings?.tenantAccountId || '',
      },
    };
  }, [
    content?.integration?._id,
    user?.profile?.email,
    content?.integration?.settings?.tenantAccountId,
  ]);

  switch (integrationProvider) {
    case IntegrationProviderEnum.BuildingEnginesPrismVisitors:
      return (
        <BEPrismTokenProvider tokenRequest={tokenRequest}>
            <VisitForm 
              content={content} 
              {...(isBEFFEnabled && { buildingId, buildings })}
            />
        </BEPrismTokenProvider>
      );
    case IntegrationProviderEnum.ProxyClick:
      // @ts-expect-error ts-migrate(2322) FIXME: Type '{ content: any; }' is not assignable to type... Remove this comment to see the full error message
      return <MeetingForm content={content} />;
    case IntegrationProviderEnum.AngusServiceRequests:
      return <RequestForm content={content} />;
    case IntegrationProviderEnum.ShopifyBurst:
      return (
        <ShopifyBurstContextProvider contentId={content?._id}>
          <BurstCreateFlow style={{ width: '100%' }} />
        </ShopifyBurstContextProvider>
      );
    case IntegrationProviderEnum.BuildingEnginesClassic:
      return <BuildingEnginesClassicRequestForm content={content} />;
    default:
      // todo: non integrations don't use this? maybe redirect them somewhere.
      return <div />;
  }
}
